import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';
import _typeof from 'babel-runtime/helpers/typeof';
import _defineProperty from 'babel-runtime/helpers/defineProperty';
import { throttle, debounce, warn } from '@xunlei/thunder-ui-vue/lib/utils/util.js';

var SliderButton = {
  props: {
    value: Number,
    disabled: Boolean
  },
  inject: ['slider'],
  data: function data() {
    return {
      dragging: false,
      currentX: undefined,
      currentY: undefined,
      startX: undefined,
      startY: undefined,
      sliderSize: undefined,
      style: {}
    };
  },

  watch: {
    value: function value(v) {
      this.setStyle();
    }
  },
  computed: {
    vertical: function vertical() {
      return this.slider.vertical;
    }
  },
  created: function created() {
    this.onDraggingThrottle = throttle(this.onDragging.bind(this), 16);
  },

  methods: {
    handleClick: function handleClick(e) {
      this.currentX = e.clientX;
      this.currentY = e.clientY;
      this.setValue(true);
    },
    onDragStart: function onDragStart(e) {
      if (this.disabled) {
        return;
      }
      this.$emit('dragStart');
      var slider = this.slider.$refs.slider;
      if (!slider) {
        return;
      }
      e.preventDefault();
      this.initPosition();
      this.dragging = true;
      this.isClick = true;
      window.addEventListener('mousemove', this.onDraggingThrottle);
      window.addEventListener('mouseup', this.onDragEnd);
      window.addEventListener('contextmenu', this.onDragEnd);
    },
    onMouseEnter: function onMouseEnter() {
      this.$emit('mouseEnter');
    },
    onMouseLeave: function onMouseLeave() {
      this.$emit('mouseLeave');
    },
    onDragging: function onDragging(e) {
      if (this.dragging) {
        e.preventDefault();
        this.isClick = false;
        if (this.vertical) {
          this.currentY = e.clientY;
        } else {
          this.currentX = e.clientX;
        }
        this.setValue();
      }
    },
    onDragEnd: function onDragEnd(e) {
      var _this = this;

      if (this.dragging) {
        // 防止在 mouseup 后立即触发 click，导致触发clean
        // 不使用 preventDefault 是因为 mouseup 和 click 没有注册在同一个 DOM 上
        setTimeout(function () {
          _this.dragging = false;
          _this.$emit('dragEnd');
          if (!_this.isClick) {
            _this.setValue();
          }
        }, 0);
      }
      window.removeEventListener('mousemove', this.onDraggingThrottle);
      window.removeEventListener('mouseup', this.onDragEnd);
      window.removeEventListener('contextmenu', this.onDragEnd);
    },
    setStyle: function setStyle(init) {
      var _slider = this.slider,
          vertical = _slider.vertical,
          scales = _slider.scales;
      var sliderSize = this.sliderSize,
          value = this.value;

      if (value === undefined || value === null) {
        this.style = _defineProperty({}, vertical ? 'bottom' : 'left', 0);
        return;
      }
      if (sliderSize === undefined) {
        if (init) {
          // 初始化时不需要位置信息，可以使用默认位置信息
          sliderSize = 100;
        } else {
          this.initPosition();
          sliderSize = this.sliderSize;
        }
      }
      var blocks = scales.length - 1;
      var blockSize = sliderSize / blocks;
      var moved = 0;
      var percent = void 0;
      var index = 1;
      while (value > scales[index]) {
        moved += blockSize;
        index++;
      }
      moved += (value - scales[index - 1]) / (scales[index] - scales[index - 1]) * blockSize;
      percent = moved / sliderSize * 100 + '%';
      this.style = _defineProperty({}, vertical ? 'bottom' : 'left', percent);
      this.$emit('update-inner-style', percent);
    },
    setValue: function setValue() {
      var isRelease = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var currentY = this.currentY,
          currentX = this.currentX,
          vertical = this.vertical,
          slider = this.slider;
      var scales = slider.scales;
      var startX = this.startX,
          startY = this.startY,
          sliderSize = this.sliderSize;

      if (sliderSize === undefined || startX === undefined || startY === undefined) {
        this.initPosition();
        startX = this.startX;
        startY = this.startY;
        sliderSize = this.sliderSize;
      }
      var blocks = scales.length - 1;
      var blockSize = sliderSize / blocks;
      var moved = void 0;
      if (vertical) {
        moved = Math.max(Math.min(sliderSize, startY - currentY), 0);
      } else {
        moved = Math.max(Math.min(sliderSize, currentX - startX), 0);
      }
      var value = scales[0];
      var index = 1;
      while (moved > blockSize) {
        moved -= blockSize;
        value += scales[index] - scales[index - 1];
        index++;
      }
      // 边界检查
      index = Math.min(index, scales.length - 1);
      value += parseInt(moved / blockSize * (scales[index] - scales[index - 1]));
      value = Math.min(scales[scales.length - 1], value);
      if (value !== this.value) {
        this.$emit('input', value);
        if (isRelease) this.$emit('release', value);
      }
    },
    initPosition: function initPosition() {
      var slider = this.slider.$refs.slider;
      if (slider) {
        var rect = slider.getBoundingClientRect();
        if (this.vertical) {
          this.sliderSize = rect.height;
          this.startY = rect.top + rect.height;
        } else {
          this.sliderSize = rect.width;
          this.startX = rect.left;
        }
      }
    },
    setSliderSize: function setSliderSize(setStyle, init) {
      var _this2 = this;

      this.$nextTick(function () {
        var slider = _this2.slider.$refs.slider;
        if (!slider) {
          return;
        }
        if (!init) {
          _this2.initPosition();
        }
        setStyle && _this2.setStyle(init);
      });
    }
  },
  mounted: function mounted() {
    this.setSliderSize(true, true);
    this.setSliderSizeDebounce = debounce(this.setSliderSize.bind(this, false), 60);
    window.addEventListener('resize', this.setSliderSizeDebounce);
  },
  render: function render() {
    var h = arguments[0];
    var style = this.style,
        vertical = this.vertical,
        disabled = this.disabled;

    return h('button', {
      'class': ['td-slider__button', disabled ? 'is-disabled' : ''],
      style: [style, vertical ? { top: 'auto' } : ''],
      on: {
        'mousedown': this.onDragStart.bind(this),
        'mouseenter': this.onMouseEnter,
        'mouseleave': this.onMouseLeave,
        'click': function click(e) {
          return e.stopPropagation();
        }
      }
    });
  }
};

var NAMESPACE = 'td';

var Slider = {
  name: NAMESPACE + '-slider',
  props: {
    showTooltip: {
      type: Boolean,
      default: false
    },
    vertical: Boolean,
    marks: Array,
    scales: {
      type: Array,
      default: function _default() {
        return [0, 100];
      }
    },
    value: Number,
    disabled: Boolean,
    renderMarksLabel: Function,
    renderMarks: Function,
    formatTooltip: {
      type: Function,
      default: function _default(val) {
        return val;
      }
    }
  },
  components: {
    SliderButton: SliderButton
  },
  data: function data() {
    return {
      valueCache: undefined,
      innerStyle: {
        height: 0
      },
      isSliderButtonDragging: false,
      isHovering: false
    };
  },
  created: function created() {
    var _this = this;

    this.$watch('value', function (v) {
      _this.valueCache = v;
    }, { immediate: true });
    if (process.env.NODE_ENV !== 'production') {
      if (this.vertical && this.marks && this.marks.length) {
        warn(NAMESPACE + '-slider', '\'marks\' parameter is not supported in vertical mode!');
      }
      if (this.value < this.scales[0] || this.value > this.scales[this.scales.length - 1]) {
        warn(NAMESPACE + '-slider', '\'value\' cannot exceed the scale range');
      }
      if (this.marks && this.marks.length && this.marks.length !== this.scales.length) {
        warn(NAMESPACE + '-slider', '\'marks\' parameter and \'scales\' parameter must correspond one by one');
      }
    }
  },
  provide: function provide() {
    return {
      slider: this
    };
  },

  methods: {
    handleSliderButtonDragEnd: function handleSliderButtonDragEnd() {
      this.isSliderButtonDragging = false;
      this.handleRelease(this.valueCache);
    },
    handleRelease: function handleRelease(v) {
      this.$emit('release', v);
    },
    handleSliderButtonDragStart: function handleSliderButtonDragStart() {
      this.isSliderButtonDragging = true;
    },
    handleUpdate: function handleUpdate(v) {
      this.valueCache = v;
      this.$emit('input', v);
      this.$emit('change', v);
    },
    handleClick: function handleClick(e) {
      if (this.disabled) {
        return;
      }
      this.$refs.button.handleClick(e);
    },
    handleUpdateInnerStyle: function handleUpdateInnerStyle(moved) {
      this.innerStyle = _defineProperty({}, this.vertical ? 'height' : 'width', moved);
    },
    handleMouseEnter: function handleMouseEnter() {
      this.isHovering = true;
    },
    handleMouseLeave: function handleMouseLeave() {
      this.isHovering = false;
    },
    handleClickMark: function handleClickMark(mark) {
      if (this.disabled) {
        return;
      }
      var value = void 0;
      if ((typeof mark === 'undefined' ? 'undefined' : _typeof(mark)) === 'object') {
        value = mark.value;
      } else {
        value = mark;
      }
      this.$emit('input', value);
    }
  },
  render: function render(h) {
    var _this2 = this;

    var vertical = this.vertical,
        innerStyle = this.innerStyle,
        marks = this.marks,
        valueCache = this.valueCache,
        disabled = this.disabled,
        scales = this.scales,
        renderMarks = this.renderMarks,
        renderMarksLabel = this.renderMarksLabel;

    var buttonProps = {
      value: valueCache,
      disabled: disabled
    };
    return h(
      'div',
      { 'class': ['td-slider', vertical ? 'is-vertical' : '', disabled ? 'is-disabled' : ''], ref: 'slider' },
      [h(
        'div',
        { 'class': 'td-slider__bar', on: {
            'click': this.handleClick
          }
        },
        [h('div', { 'class': 'td-slider__bar-inner', style: innerStyle }), renderMarks ? renderMarks.call(this.$parent._renderProxy, h, valueCache) : marks && marks.map(function (mark, index) {
          var percent = 1 / (marks.length - 1) * 100 * index + '%';
          var style = _defineProperty({}, vertical ? 'top' : 'left', percent);
          return h('div', { 'class': ['td-slider__dot', valueCache > scales[index] ? 'is-active' : ''], style: style });
        }), h(SliderButton, _mergeJSXProps([{
          on: {
            'input': this.handleUpdate,
            'release': this.handleRelease,
            'mouseEnter': this.handleMouseEnter,
            'mouseLeave': this.handleMouseLeave,
            'update-inner-style': this.handleUpdateInnerStyle,
            'dragEnd': this.handleSliderButtonDragEnd,
            'dragStart': this.handleSliderButtonDragStart
          }
        }, { props: buttonProps }, {
          ref: 'button'
        }])), this.showTooltip && (this.isSliderButtonDragging || this.isHovering) && h(
          'div',
          {
            'class': 'td-slider__tips is-active',
            style: this.vertical ? { bottom: '' + this.innerStyle['height'] } : { left: this.innerStyle['width'] }
          },
          [this.formatTooltip(this.value)]
        )]
      ), renderMarksLabel ? h(
        'div',
        { 'class': 'td-slider__mark' },
        [renderMarksLabel.call(this.$parent._renderProxy, h, valueCache, this.handleClickMark)]
      ) : marks && marks.length && h(
        'div',
        { 'class': 'td-slider__mark' },
        [marks && marks.map(function (mark, index) {
          var percent = 1 / (marks.length - 1) * 100 * index + '%';
          var style = {};
          vertical ? style.top = percent : style.left = percent;
          return h(
            'div',
            { 'class': 'td-slider__mark-text', style: style, on: {
                'click': _this2.handleClickMark.bind(_this2, mark)
              }
            },
            [(typeof mark === 'undefined' ? 'undefined' : _typeof(mark)) === 'object' ? mark.label : mark]
          );
        })]
      )]
    );
  }
};

Slider.install = function (Vue) {
  return Vue.component(Slider.name, Slider);
};

export default Slider;
